<section class="container-fluid admin-header">
    <div class="row">
        <div class="admin-title col-5">
            {{title}}
        </div>
        <div class="col-7" style="line-height: 2.5em;font-size: 1.5rem;text-align: right;">
            {{subtitle}}
        </div>
    </div>    
</section>

<nav class="navbar navbar-expand navbar-dark bg-dark" *ngIf="user">
    <ul class="navbar-nav mr-auto">
        <li class="nav-item "><a class="nav-link" href="http://ohi.net">OHI.NET</a></li>
        <a class="nav-item nav-link" routerLink="/" [routerLinkActiveOptions]="{exact: true}">Home</a>
        <a class="nav-item nav-link" routerLink="/university" [routerLinkActiveOptions]="{exact: true}">OHI University</a>
        <a *ngIf="canManageUsers()" class="nav-item nav-link" routerLink="/account/user-maintenance" [routerLinkActiveOptions]="{exact: true}">Users</a>
    </ul>
    <ul *ngIf="user" class="navbar-nav">
        <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <fa-icon [icon]="['fas', 'user-shield']"></fa-icon><span>{{user.firstName}} {{user.lastName}}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item"  routerLink="/account/setup" [routerLinkActiveOptions]="{exact: true}">
                    <fa-icon [icon]="['fas', 'users-cog']"></fa-icon>
                    <span>Settings</span>
                </a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" (click)="logout()">
                    <fa-icon [icon]="['fas', 'sign-out-alt']"></fa-icon>
                    <span>Logout</span>
                </a>
            </div>
        </li>
    </ul>
</nav>

<!-- main app container -->
<div class="app-container" [ngClass]="{ 'bg-light': user }">
    <alert></alert>
    <router-outlet></router-outlet>
</div>